import * as React from 'react';
import { useNavigate, useLocation, matchPath } from 'react-router-dom';
import { Button, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { usePageNavsStore } from '@src/shared/store/navs';
import TabLink from './TabLink';
import * as Styled from './styled';

const NavTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navs, remove, getRoutePath } = usePageNavsStore();

  return (
    <Styled.Container>
      {navs.map((item) => {
        const path = getRoutePath(item) ?? '/';
        const active = !!matchPath({ path, end: path === '/' }, location.pathname);

        return (
          <TabLink
            key={item.id}
            to={`${path}${item.search ?? ''}`}
            // Have to spread state object to avoid immer proxy issue
            state={{ ...item.state }}
            active={active}
            closeable={item.type !== 'static'}
            onClose={(e) => {
              e.stopPropagation();
              e.preventDefault();

              if (active) {
                void navigate('/', { replace: true });
              }
              remove(item.id);
            }}
          >
            {item.name}
          </TabLink>
        );
      })}
      <Tooltip title="Create Funnel Analysis">
        <Styled.BlankFunnelLink to="/funnels/temp" state={{}}>
          <Button variant="text" color="default" size="small" icon={<PlusOutlined />} />
        </Styled.BlankFunnelLink>
      </Tooltip>
    </Styled.Container>
  );
};

export default React.memo(NavTabs);
